<template> 
  <div class="aftermarket">
    <div class="banner">
      <img :src="$store.state.isMB?'static/mbimages/aftermarket/banner.png':'static/images/aftermarket/banner.jpg'" alt="">
      <div class="textNtitle">
        <div class="banner_title">汽车后市场业务</div>
        <div class="banner_text">依托深耕汽车后市场二十余年沉淀的行业数据资源，打通产业链各主体业务需求。
            <br>深耕汽车后市场，为客户提供信息技术与服务支持，
            <br class="mbchangeLine">打通产业上下游协同链路，完善全流程服务体系，共建良性产业协作生态
        </div>
      </div>
    </div>
    <div class="marketbizs">
      <div class="info_title">
        <span>汽车后市场业务</span>
      </div>
      <div class="bizstype">
        <div class="bizsList" v-for="bizs in bizsList" :key="bizs.title">
          <img :src="bizs.url" alt="">
          <div class="tilte">{{bizs.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      bizsList: [
        { title: '汽车维修', url: 'static/images/aftermarket/1.png' },
        { title: '配件修复', url: 'static/images/aftermarket/2.png' },
        { title: '配件供应', url: 'static/images/aftermarket/3.png' },
        { title: '二手车拍卖', url: 'static/images/aftermarket/4.png' },
        { title: '残值拍卖', url: 'static/images/aftermarket/5.png' },
        { title: '', url: 'static/images/aftermarket/6.png' }
      ]
    }
  },
  mounted () {
    window.scroll(0,0)
  },
}
</script>
<style lang="scss">
.aftermarket{
  .banner{
    .textNtitle{
      @media screen and (max-width: 767px){
        top: 23%;
      }
    }
    .banner_text{
      font-size: 18px;
      line-height: 30px;
      @media screen and (max-width: 767px){
        font-size: 14px;
        line-height: 22px;
        margin-top: 3%;
      }
      @media screen and (max-width: 368px){
        font-size: 12px;
      }
    }
  }
  .marketbizs{
    .info_title{
      width: 268px;
      margin: 83px auto 73px;
      @media screen and (max-width: 767px){
        width: 200px;
        margin: 40px auto 45px;
      }
    }
  }
  .bizstype{
    width: 1200px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: 47px;
    @media screen and (max-width: 767px){
      width: 100%;
      padding: 0 4% 40px;
    }
    .bizsList{
      width: 372px;
      height: 300px;
      text-align: center;
      margin-bottom: 31px;
	    box-shadow: 0px 2px 6px 0px rgba(29, 35, 41, 0.12);
      &:hover{
        @media screen and (min-width: 768px){
          box-shadow: 0px 2px 6px 0px rgba(29, 35, 41, 0.25);
        }
      }
      @media screen and (max-width: 767px){
        width: 100%;
        height: fit-content;
        padding-bottom: 30px;
      }
      img{
        display: block;
        margin: 44px auto 45px;
        @media screen and (max-width: 767px){
          margin: 35px auto 40px;
        }
      }
      &:nth-of-type(6){
        @media screen and (max-width: 767px){
          height: 150px;
        }
        img{
          margin-top: 143px;
          @media screen and (max-width: 767px){
            margin-top: 65px;
          }
        }
      }
      .tilte{
        font-size: 18px;  
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/comPages/afterMarket.vue